<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '3' }}</span></div>
        <h4>Outcome</h4>
    </div>
    <ng-container *ngIf="isActive()">
        <div>
            <div class="body-1 mb-8">Choose the outcome metric of your analysis, e.g. "Revenues", "Margin", "Total Production", etc</div>
            <div #tableContainer class="table-container column-border table-big">
                <!-- Header row -->
                <div class="row header">
                    <div *ngFor="let col of columns" class="cell" (click)="selectColumn(col)" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <div class="subtitle-2">{{col.name}}</div>
                        <span class="body-2">{{ displayRoughNum(col.uniqueValues) }}</span>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length">
                            {{col.someVals[0]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                            {{col.someVals[1]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                            {{col.someVals[2]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                            {{col.someVals[3]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                            {{col.someVals[4]}}
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="body-1 mb-8">Select depth of analysis</div>
            <div class="radio-group separate-blocks">
                <label>
                    <input type="radio" name="analysis" [(ngModel)]="haveFormula" [value]="true">
                    <div class="radio-option">
                        <div class="radio-circle"></div>
                        <div class="radio-content">
                            <span class="subtitle-1">Break down outcome into components</span>
                            <span class="body-2">e.g. break down "Revenues" into "Quantity" times "Price"</span>
                        </div>
                    </div>
                </label>
                <label>
                    <input type="radio" name="analysis" [(ngModel)]="haveFormula" [value]="false">
                    <div class="radio-option">
                        <div class="radio-circle"></div>
                        <div class="radio-content">
                            <span class="subtitle-1">Just focus on outcome</span>
                            <span class="body-2">without breaking out the components</span>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <div>
            <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div class="d-flex">
            <div class="info-block">
                <span class="body-1">Metric</span>
                <span *ngIf="selectedColumn" class="body-1 text-900">{{selectedColumn.name}}</span>
            </div>
            <div class="info-block">
                <span class="body-1">Depth of analysis</span>
                <span class="body-1 text-900">{{ haveFormula ? 'Break down outcome' : 'Just focus on outcome' }}</span>
            </div>
        </div>
        <div>
            <button (click)="editClick()" [ngClass]="{'loading-small':loading}" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
